import "react-perfect-scrollbar/dist/css/styles.css";
import React, { Component } from "react";
import Message from "./Messages";
import PerfectScrollbar from "react-perfect-scrollbar";
import _ from "lodash";
import Launcher from "./Launcher";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  fetchUserSkillHistory,
  keepScrollPosition,
  updateCurrentScrollPosition
} from "../../../../../redux/actions/chatActions";
import { getUserDisplayName } from "../../../../../utils";
import { getChatConfigProp } from "../../../../../common/utils";

class MessageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (!_.isEqual(_.get(this.props, "chat.chatPosition", {}), _.get(nextProps, "chat.chatPosition", {}))) {
      return;
    }

    if (!_.isEqual(_.get(this.props, "chat.chatSize", {}), _.get(nextProps, "chat.chatSize", {}))) {
      return;
    }

    if (
      _.get(nextProps, "chat.chatUserHistory.Items", false) &&
      _.get(this.props, "chat.chatUserHistory.Items", false) &&
      nextProps.chat.chatUserHistory.Items !== this.props.chat.chatUserHistory.Items
    ) {
      this.props.keepScrollPosition(this.scrollList._container.scrollHeight);
    }

    if (
      _.get(this.props, "chat.chatUserHistory.currentScrollPosition") !==
      _.get(nextProps, "chat.chatUserHistory.currentScrollPosition")
    ) {
      return;
    }

    if (nextProps.source === "hierarchy") {
      return;
    }

    if (
      (_.get(nextProps, "chat.chatUserHistory.initialLoad", false) &&
        nextProps.chatVisible &&
        this.props.chatVisible) ||
      nextProps.source === "typing"
    ) {
      if (this.state.mounted || nextProps.chatVisible !== this.props.chatVisible) {
        this.scrollList._container.scrollTop = _.get(nextProps, "chat.chatUserHistory.currentScrollPosition.scTop", {});

        this.setState({ mounted: false });
      } else {
        try {
          this.scrollList._container.scrollTop = this.scrollList._container.scrollHeight;
        } catch (e) {}
      }
    } else {
      if (this.state.mounted || nextProps.chatVisible !== this.props.chatVisible) {
        this.scrollList._container.scrollTop = _.get(nextProps, "chat.chatUserHistory.currentScrollPosition.scTop", {});

        this.setState({ mounted: false });
      } else {
        try {
          this.scrollList._container.scrollTop =
            this.scrollList._container.scrollHeight - nextProps.chat.chatUserHistory.scrollPosition;
        } catch (e) {
          console.error(e);
        }
      }
    }

    if (nextProps.messages.length > 0) {
      let lastMessage = _.last(nextProps.messages);
      if (lastMessage.data.text.indexOf("has expired. Please link your account. <a href") > 0) {
        let message_item;
        let exit_signal = false;
        let positive_detected = 0;
        // console.log("Messages", nextProps.messages);
        for (let i = nextProps.messages.length - 1; i >= 0; i--) {
          // console.log("itteration", i, nextProps.messages[i]);
          if (_.get(nextProps.messages[i], "data.dialogElicitSlot", false) && nextProps.messages[i].author === "me") {
            if (_.get(nextProps.messages[i], "hidden", false)) {
              continue;
            }
            // localStorage.setItem("last_chat_message", JSON.stringify(nextProps.messages[i]));
            message_item = nextProps.messages[i];

            if (i < positive_detected && i - positive_detected > 2) {
              exit_signal = true;
            } else {
              positive_detected = i;
            }
          }

          if (i === 0 && message_item) {
            exit_signal = true;
          }

          if (exit_signal) {
            localStorage.setItem("last_chat_message", JSON.stringify(message_item));
            this.props.removeDialogElicit();
            break;
          }
        }
      }
    }
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  onUppScroll = () => {
    this.props.updateCurrentScrollPosition({
      psTop: this.scrollList._ps.scrollbarY.style.top,
      scTop: this.scrollList._container.scrollTop
    });
    if (this.scrollList._ps.scrollbarY.style.top === "0px") {
      this.props.fetchUserSkillHistory(false);
    }
  };

  render() {
    return (
      <PerfectScrollbar className="sc-message-list" ref={el => (this.scrollList = el)} onScrollY={this.onUppScroll}>
        {this.props.messages.map((message, i) => {
          if (_.get(message, "hidden", false)) {
            return;
          }
          return (
            <Message
              message={message}
              key={i}
              userImage={this.props.userImage}
              userFullName={this.props.userFullName}
            />
          );
        })}
      </PerfectScrollbar>
    );
  }
}

function mapStateToProps(state) {
  return {
    chat: state.chat,
    chatVisible: getChatConfigProp(state, "chatVisible")
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchUserSkillHistory,
        keepScrollPosition,
        updateCurrentScrollPosition
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageList);
